import categoryService from "../services/categoryService";

export const GET_CATEGORY = "GET_CATEGORY";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_ERROR = "GET_CATEGORY_ERROR";

export const CREATE_OR_UPDATE_CATEGORY = "CREATE_OR_UPDATE_CATEGORY";
export const CREATE_OR_UPDATE_CATEGORY_SUCCESS = "CREATE_OR_UPDATE_CATEGORY_SUCCESS";
export const CREATE_OR_UPDATE_CATEGORY_ERROR = "CREATE_OR_UPDATE_CATEGORY_ERROR";

export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST ";
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST _SUCCESS";
export const GET_CATEGORY_LIST_ERROR = "GET_CATEGORY_LIST _ERROR";

export function getCategoryRecord(query) {
  return async (dispatch) => {
    dispatch(getCategory());
    return await categoryService
      .getCategory(query)

      .then((response) => dispatch(getCategorySuccess(response.data)))
      .catch((error) => dispatch(getCategoryError(error)));
  };
}

export function getCategory() {
  return {
    type: GET_CATEGORY,
  };
}

export function getCategorySuccess(success) {
  return {
    type: GET_CATEGORY_SUCCESS,
    payload: { success },
  };
}

export function getCategoryError(error) {
  return {
    type: GET_CATEGORY_ERROR,
    payload: { error },
  };
}

export function createOrUpdateCategoryRecord(category) {
  return async (dispatch) => {
    dispatch(createOrUpdateCategory());
    return await categoryService
      .createOrUpdateCategory(category)
      
      .then((response) => dispatch(createOrUpdateCategorySuccess(response.data)))
      .catch((error) => dispatch(createOrUpdateCategoryError(error)));
  };
}

export function createOrUpdateCategory() {
  return {
    type: CREATE_OR_UPDATE_CATEGORY,
  };
}

export function createOrUpdateCategorySuccess(success) {
  return {
    type: CREATE_OR_UPDATE_CATEGORY_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateCategoryError(error) {
  return {
    type: CREATE_OR_UPDATE_CATEGORY_ERROR,
    payload: { error },
  };
}

export function getCategoryListRecord(query) {
  return async (dispatch) => {
    dispatch(getCategoryList());
    return await categoryService
      .getCategoryList(query)

      .then((response) => dispatch(getCategoryListSuccess(response)))
      .catch((error) => dispatch(getCategoryListError(error)));
  };
}

export function getCategoryList() {
  return {
    type: GET_CATEGORY_LIST,
  };
}

export function getCategoryListSuccess(success) {
  return {
    type: GET_CATEGORY_LIST_SUCCESS,
    payload: { success },
  };
}

export function getCategoryListError(error) {
  return {
    type: GET_CATEGORY_LIST_ERROR,
    payload: { error },
  };
}